import { Component, OnDestroy, OnInit } from '@angular/core';
// import { GodCreate } from '../../../../core/model/god-create/god-create.model';
import { BaseTableComponent } from '../../../../core/helpers/table/basetable';
// import { GodUserService } from '../../../../core/service/api/god-user.service';
import { Subscription } from 'rxjs';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { GodCreate } from '../../../../core/model/god/god_create';
import { GodUserService } from '../../../../core/service/api/god.user.service';

@Component({
    selector: 'app-god-user-list',
    templateUrl: './god-user-list.component.html',
    styleUrls: ['./god-user-list.component.scss']
})
export class GodUserListComponent extends BaseTableComponent implements OnInit, OnDestroy {
    private _subscriptions: Array<Subscription> = [];
    _godUsers: GodCreate[] = [];
    _godUser: GodCreate = new GodCreate();
    _isVisible: boolean = false;
    _isEdit: boolean = false;
    _modalType: string = '';

    constructor(
        private _godUserService: GodUserService,
        private _tranlateService: TranslateService,
        private _nzMessageService: NzMessageService,
    ) {
        super();
    }

    ngOnInit() {
        this.GETGodUsers();
    }

    openModal(type: string, _selectedGodUser?: GodCreate) {
        switch (type) {
            case 'CREATE':
                this._modalType = this._tranlateService.instant('modal.create');
                this._isVisible = true;
                this._isEdit = false;
                this._godUser = new GodCreate();
                break;
            case 'EDIT':
                this._modalType = this._tranlateService.instant('modal.edit');
                this._isVisible = true;
                this._isEdit = true;
                this._godUser = _selectedGodUser ? Object.assign(new GodCreate(), _selectedGodUser) : new GodCreate();
                this._godUser.password = ''; // Non pre-popolare la password
                break;
            case 'DELETE':
                this._modalType = this._tranlateService.instant('modal.delete');
                this._isVisible = false;
                this._godUser = _selectedGodUser ? Object.assign(new GodCreate(), _selectedGodUser) : new GodCreate();
                this.DELETEGodUser();
                break;
            default:
                this._isVisible = false;
                this._isEdit = false;
                this._godUser = new GodCreate();
                break;
        }
    }

    noDelete(): void { }

    private GETGodUsers() {
        this._loading = true;
        this._subscriptions.push(this._godUserService.GETGodUsers(this._paging).subscribe({
            next: (response: any) => {
                this._godUsers = response.data.data;
                this._totalItems = response.data.count;
                this._loading = false;
            },
            error: () => {
                this._loading = false;
            }
        }));
    }

    private DELETEGodUser() {
        this._loading = true;
        this._subscriptions.push(this._godUserService.DELETEGodUser(this._godUser.id).subscribe({
            next: () => {
                this._nzMessageService.success(this._tranlateService.instant('alert.success.godUserDeleted'));
                this.GETGodUsers();
                this._loading = false;
            },
            error: (err: any) => {
                this._nzMessageService.error(this._tranlateService.instant('alert.error.godUserDeleted'));
                this._loading = false;
                throw new Error(err);
            }
        }));
    }

    handleCancel(): void {
        this._isVisible = false;
    }

    handleOk(): void {
        this._isVisible = false;
        const body = this._godUser.dto(this._isEdit);

        if (this._isEdit) {
            this._subscriptions.push(this._godUserService.PUTGodUser(this._godUser.id, body).subscribe({
                next: () => {
                    this._nzMessageService.success(this._tranlateService.instant('alert.success.godUserUpdated'));
                    this.GETGodUsers();
                },
                error: (err: any) => {
                    this._nzMessageService.error(this._tranlateService.instant('alert.error.godUserUpdated'));
                    throw new Error(err);
                }
            }));
        } else {
            this._subscriptions.push(this._godUserService.POSTGodUser(body).subscribe({
                next: () => {
                    this._nzMessageService.success(this._tranlateService.instant('alert.success.godUserCreated'));
                    this.GETGodUsers();
                },
                error: (err: any) => {
                    this._nzMessageService.error(this._tranlateService.instant('alert.error.godUserCreated'));
                    throw new Error(err);
                }
            }));
        }
    }

    onQueryChange(params: NzTableQueryParams) {
        this.onQueryParamsChange(params, () => this.GETGodUsers());
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(sub => sub.unsubscribe());
    }
}